module.exports = require('./helpers/bundle-url').getBundleURL('fD1a9') + "logo-dark.eefe0b7f.svg";